/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { User } from "firebase/auth";

export interface IUserState {
  signedIn: boolean;
  user: User;
  idToken: string;
  organization?: {
    name: string;
    id: string;
  }
}

export const state: IUserState = {
  signedIn: false,
  user: {} as User,
  idToken: ""
};